import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Form, FormSpy, Field } from 'react-final-form'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import RefreshIcon from '@material-ui/icons/Refresh'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import cookie from 'react-cookies'

import MainLayout from 'layout/MainLayout'
import api from 'utils/api'
import MSortTable from 'components/MSortTable/MSortTable'
import MDateRangePicker from 'components/forms/MDateRangePicker'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      minWidth: 110,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    button: {
      height: 50,
      verticalAlign: 'middle',
    },
    table: {
      maxHeight: 'calc(100vh - 200px)',
      minHeight: 'calc(100vh - 200px)',
    },
    backDrop: {
      zIndex: 5,
    },
  }),
)

const columns: TableColumnDef[] = [
  { field: 'page_location', headerName: 'Landing Page', width: '600' },
  { field: 'views', headerName: 'Views', align: 'center', width: '80' },
  { field: 'clicks', headerName: 'Clicks', align: 'center', width: '80' },
  { field: 'ctr', headerName: 'CTR', align: 'center', width: '80' },
  {
    field: 'cpc_clicks',
    headerName: 'CPC Clicks',
    align: 'center',
    width: '80',
  },
  { field: 'leads', headerName: 'Leads', align: 'center', width: '80' },
  { field: 'conv_rate', headerName: 'CR', align: 'center', width: '80' },
]

let defaultFilter = {
  dateRange: {
    startDate: new Date(),
    endDate: new Date(),
  },
}

const BlankComponent = () => (
  <>
  </>
)

type Props = {
  project?: string
}
const LandingPage: React.FC<Props> = ({ project }) => {
  const classes = useStyles()
  const [state, setState] = useState<{
    loading: boolean
    rows: any[]
    filter?: any
  }>({
    loading: true,
    rows: [],
    filter: defaultFilter,
  })

  const fetchData = async (params: any) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }))

    try {
      const res = await api.get('/landing', {
        ...params,
        ...params.dateRange,
        project: project,
        dateRange: undefined,
      })

      setState((prev) => ({
        ...prev,
        loading: false,
        rows: res,
        filter: params,
      }))

    } catch {
      setState((prev) => ({
        ...prev,
        loading: false,
      }))
    }
  }

  const onChange = (props: any) => {
    cookie.save('date-range', props.values.dateRange, { path: '/' })

    fetchData(props.values)
  }

  const onRowClick = (open:boolean, row: any) => {
    cookie.save('landingInfo', {...row, project:project}, {path:'/'})
    cookie.save('landing-dateRange', state.filter.dateRange, {path: '/'})
    window.open('/landing-detail', '_blank')
  }

  useEffect(() => {
    fetchData(defaultFilter)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchData(state.filter)
  }, [project]) //eslint-disable-line react-hooks/exhaustive-deps

  const dateRange = cookie.load('date-range')
  defaultFilter.dateRange = dateRange || defaultFilter.dateRange
  
  return (
    <MainLayout title='Landing Page'>
      <>
        <Form
          initialValues={defaultFilter}
          onSubmit={fetchData}
          render={({ handleSubmit, values }) => (
            <form className={classes.form} onSubmit={handleSubmit} noValidate>
              <FormSpy subscription={{ values: true }} onChange={onChange} />
              <Grid container alignItems='center' spacing={2}>
                <Grid item style={{ marginLeft: 'auto' }}>
                  <Button
                    type='submit'
                    variant='contained'
                    color='secondary'
                    className={classes.button}
                    startIcon={<RefreshIcon />}
                  >
                    Refresh Data
                  </Button>
                </Grid>
                <Grid item>
                  <Field
                    label='Date Range'
                    name='dateRange'
                    render={(props) => <MDateRangePicker {...props} />}
                  />
                </Grid>
              </Grid>
            </form>
          )}
        />

        <MSortTable
          columns={columns}
          rows={state.rows}
          className={classes.table}
          expandTable={true}
          detailComponent={BlankComponent}
          onExpand={onRowClick}
          paginate={false}
          showComprehensiveData={true}
        />
        <Backdrop open={state.loading} className={classes.backDrop}>
          <CircularProgress color='inherit' />
        </Backdrop>
      </>
    </MainLayout>
  )
}

const mapStateToProps = (state) => {
  return state.project
}
export default connect(mapStateToProps)(LandingPage)
